import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createMyCompany, deleteMyCompany, getMyCompanies, updateMyCompany } from '../services/api.js'

const KEY = ['myCompanies']

/** Compte > Mon entreprise : sociétés « Prestataire » (organisation, ou utilisateur seul). */
export function useMyCompanies() {
  const queryClient = useQueryClient()
  const onSuccess = () => queryClient.invalidateQueries({ queryKey: KEY })
  const query = useQuery({ queryKey: KEY, queryFn: getMyCompanies })

  return {
    ...query,
    companies: query.data?.companies ?? [],
    create: useMutation({ mutationFn: createMyCompany, onSuccess }),
    update: useMutation({ mutationFn: updateMyCompany, onSuccess }),
    remove: useMutation({ mutationFn: deleteMyCompany, onSuccess }),
  }
}
